import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import api from '../../services/api';
import { FinCheck } from '../FinField';
import { estadoPagamentoLegado } from './pagamentoLegadoPolicy';

export default function PagamentoLegadoParcela({ info, editavel = true, somenteMarcacao = false, onAtualizado }) {
    const [atual, setAtual] = useState(info);
    const [salvando, setSalvando] = useState(false);
    useEffect(() => { setAtual(info); }, [info]);
    const estado = estadoPagamentoLegado(atual);
    if (!estado) return null;

    const alterar = async (paga) => {
        if (salvando || !editavel || !estado.editavel) return;
        setSalvando(true);
        try {
            const res = await api({ method: 'put',
                action: `/orcamentoPagamentoParcela/${atual.previsao_parcela_id}/pagamentoLegado`,
                token: localStorage.getItem('token'), data: { paga } });
            const confirmado = res.data?.data?.pagamento_legado;
            if (!res.data?.status || !confirmado) throw new Error(res.data?.error || 'Não foi possível salvar a marcação.');
            setAtual(confirmado);
            if (onAtualizado) onAtualizado(confirmado);
        } catch (e) {
            toast.error(e.response?.data?.error || e.message || 'Não foi possível salvar a marcação.');
        } finally {
            setSalvando(false);
        }
    };

    return (
        <div className="fin-pp__legado" data-pagamento-legado={estado.paga ? 'paga' : 'nao-paga'} aria-busy={salvando} onClick={e => e.stopPropagation()}>
            <span className={'fin-pp__pill ' + (estado.paga ? (estado.baixada ? 'is-ok' : 'is-warn') : 'is-muted')}>
                {estado.titulo}
            </span>
            {!somenteMarcacao && estado.orientacao && <div className="fin-pp__legado-aviso">{estado.orientacao}</div>}
            {editavel && estado.editavel && (
                <FinCheck label={salvando ? 'Salvando…' : 'Parcela paga no processo antigo'}
                    checked={estado.paga} disabled={salvando} onChange={e => alterar(e.target.checked)} />
            )}
            {editavel && atual.bloqueio && <div className="fin-pp__cell-muted">{atual.bloqueio}</div>}
        </div>
    );
}
